﻿import { DataGrid, SettingStorage } from "@serenity-is/corelib";
import { htmlEncode, format, notifySuccess, notifyWarning, localText, trimToNull } from "@serenity-is/corelib/q";

/**
 * A mixin that can be applied to a DataGrid for favorite views functionality
 */
export class FavoriteViewsMixin<TItem> {

    private dataGrid: DataGrid<TItem, any>;
    private ul: JQuery;

    constructor(private options: FavoriteViewsMixinOptions<TItem>) {
        var dg = this.dataGrid = options.grid;

        var dropdown = $(`
<div class="dropdown favorite-views" style="float: right">
  <button class="btn btn-primary dropdown-toggle" type="button" id="${dg.element.attr('id')}_Favorites" data-toggle="dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
    <i class="fa fa-star"></i> ${htmlEncode(localText("Site.FavoriteViewsMixin.FavoriteViews"))}
    <span class="caret"></span>
  </button>
  <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
    <li class="save">
        <div>${htmlEncode(localText("Site.FavoriteViewsMixin.SaveView"))}</div>
        <div><input type="text"></div>
        <div><button class="btn btn-primary save-button"><i class="fa fa-floppy-o"></i> ${htmlEncode(localText("Site.FavoriteViewsMixin.SaveButton"))}</button></div>
    </li>
  </ul>
</div>
`)
            .prependTo(dg.element.find(".grid-title"));

        dropdown.on('shown.bs.dropdown', e => {
            dropdown.find('input[type=text]').focus();
        });

        var viewName = dropdown.find('li.save input[type=text]');

        dropdown.find('button.save-button').click(() => {
            var name = trimToNull(viewName.val());
            if (!name) {
                notifyWarning(localText("Site.FavoriteViewsMixin.EmptyNameError"));
                return;
            }

            var favorites = this.getFavorites();
            favorites[name] = (dg as any).getCurrentSettings();
            this.saveFavorites(favorites);
            notifySuccess(format(localText("Site.FavoriteViewsMixin.SaveSuccessMessage"), name));
            viewName.val('');
            this.populateFavorites();
        });

        this.ul = dropdown.children("ul");
        this.ul.on('click', 'i.fa-trash-o', e => {
            var name = $(e.target).closest('li').children('a').text();
            var favorites = this.getFavorites();
            delete favorites[name];
            this.saveFavorites(favorites);
            this.populateFavorites();
            notifyWarning(format(localText("Site.FavoriteViewsMixin.DeleteSuccessMessage"), name));
        });

        this.ul.on('click', 'a', e => {
            var name = $(e.target).text();
            var favorites = this.getFavorites();
            var settings = favorites[name];
            if (settings) {
                (dg as any).restoreSettings(settings);
                dg.refresh();
                notifySuccess(format(localText("Site.FavoriteViewsMixin.LoadedViewMessage"), name));
            }
        });

        this.populateFavorites();
    }

    private populateFavorites() {
        var favorites = this.getFavorites();

        var saveLI = this.ul.children('.save');
        this.ul.children().not(saveLI).remove();

        var keys = Object.keys(favorites).sort();
        if (keys.length) {
            for (var k of keys) {
                var li = $('<li class="fav"><a href="javascript:;"></a></li>')
                    .insertBefore(saveLI)
                    .children('a')
                    .text(k)
                    .end();

                $('<i class="fa fa-trash-o pull-right"></i>')
                    .attr('title', localText("Site.FavoriteViewsMixin.DeleteButtonHint"))
                    .appendTo(li);
            }

            $('<li role="separator" class="divider"></li>').insertBefore(saveLI);
        }
    }

    private saveFavorites(favorites: object) {
        var storage = (this.dataGrid as any).getPersistanceStorage() as SettingStorage;
        var key = "Views:" + (this.dataGrid as any).getPersistanceKey();
        storage.setItem(key, JSON.stringify(favorites));
    }

    private getFavorites() {
        var storage = (this.dataGrid as any).getPersistanceStorage() as SettingStorage;
        var key = "Views:" + (this.dataGrid as any).getPersistanceKey();
        return JSON.parse(storage.getItem(key) || "{}") || {};
    }
}

export interface FavoriteViewsMixinOptions<TItem> {
    // data grid object
    grid: DataGrid<TItem, any>;
}